import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@workspace/ui/components/spinner';

import { useOauth } from '~/hooks/use-oauth';

export const Route = createFileRoute('/oauth')({
  component: AuthPage,
});

function AuthPage() {
  const queryParams = new URLSearchParams(window.location.search);

  const { isLoading, message } = useOauth({
    code: queryParams.get('code'),
    state: queryParams.get('state'),
    authFlow: queryParams.get('authFlow'),
    authorizationUrl: queryParams.get('authorizationUrl'),
    data: queryParams.get('data'),
    redirect: queryParams.get('redirect'),
  });

  if (isLoading) return <Spinner message={message} />;

  return null;
}
